import { Box } from '@mui/material'

interface ButtonProps {
  onClick: () => void
  buttonIcon: string
  buttonName: string
  active: boolean
  label?: string
}

const JourneyTypeButton = (props: ButtonProps) => {
  const {
    active,
    buttonName,
    buttonIcon,
    onClick,
    label = 'ARRIVING SOON!',
  } = props
  return (
    <Box
      component="div"
      sx={[
        active && {
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: '#ffffff',
            color: 'var(--jy-navy-900, #00253d)',
          },
        },
        {
          position: 'relative',
          backgroundColor: '#f4f4f4',
          padding: '30px 50px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: '#414042',
          overflow: 'hidden',
          maxWidth: '300px',
          maxHeight: '300px',
          height: 'auto',
          aspectRatio: '1/1',
        },
      ]}
      onClick={() => (active ? onClick() : null)}
    >
      <Box
        component={'img'}
        src={buttonIcon}
        alt={buttonName}
        sx={[
          !active && { filter: 'grayscale(100%)', opacity: '50%' },
          { height: '160px' },
        ]}
      />

      <Box
        component="p"
        sx={{
          marginTop: '10px',
          fontSize: '20px',
          textTransform: 'uppercase',
        }}
      >
        {buttonName}
      </Box>
      {!active && (
        <Box
          component="p"
          sx={{
            backgroundColor: '#efefef',
            color: 'var(--jy-navy-900, #00253d)',
            fontSize: '11px',
            fontWeight: 'thin',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            paddingLeft: '10px',
            paddingRight: '10px',
            zIndex: '100',
          }}
        >
          {label}
        </Box>
      )}
    </Box>
  )
}

export default JourneyTypeButton
